import { useEffect } from "react";

// Canonical domain: we want everyone to land on the .org once it is active.
const PRIMARY_HOST = "dallasearlychildhoodresourceinstitute.org";

// Visitors arriving on these .com hosts should be forwarded to the .org —
// but ONLY after the .org is actually reachable, so we never redirect the
// currently-working .com to an inactive .org (e.g., while it is on client hold).
const SOURCE_HOSTS = [
  "dallasearlychildhoodresourceinstitute.com",
  "www.dallasearlychildhoodresourceinstitute.com",
];

const CanonicalRedirect = () => {
  useEffect(() => {
    const host = (window.location.hostname || "").toLowerCase();
    if (!SOURCE_HOSTS.includes(host)) return; // do nothing on preview/localhost/.org

    let cancelled = false;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 3000);

    const probeAndRedirect = async () => {
      try {
        // A successful (even opaque) response means the .org is live and serving.
        await fetch(`https://${PRIMARY_HOST}/favicon.ico?cb=${Date.now()}`, {
          mode: "no-cors",
          cache: "no-store",
          signal: controller.signal,
        });
        if (cancelled) return;
        const target = `https://${PRIMARY_HOST}${window.location.pathname}${window.location.search}${window.location.hash}`;
        window.location.replace(target);
      } catch (e) {
        // .org not reachable yet — keep serving the .com so the site stays up.
      }
    };

    probeAndRedirect();
    return () => {
      cancelled = true;
      clearTimeout(timer);
      controller.abort();
    };
  }, []);

  return null;
};

export default CanonicalRedirect;
